module.exports = __webpack_public_path__ + "baby_chalkboard-baby_1.jpg";